(function(){
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('classy').component('egPayPaypalCommerce', {
  templateUrl: 'global/embedded-giving/pay/components/paypal/eg.pay.components.paypal-commerce', // same folder as this
  bindings: {
    hasPaypal: '<',
    hasVenmo: '<',
    modelPaypal: '<',
    modelVenmo: '<',
    amount: '<',
    fot: '<',
    frequency: '<',
    onSuccess: '&',
    onCancel: '&',
    enablePaymentButtons: '&',
    disablePaymentButtons: '&'
  },
  controller: ["$log", "$timeout", "bugsnagClient", "PayPalSDK", "cpConstants", "scFeeOnTopService", "scOrganizationsService", "$q", function controller($log, $timeout, bugsnagClient, PayPalSDK, cpConstants, scFeeOnTopService, scOrganizationsService, $q) {
    var _this = this;

    var self = this;
    var STATUS = cpConstants.STATUS;

    var PAYPAL_FEE_RATE = 0.018;
    var PAYPAL_FEE_FIXED = 0.3;
    var requestCanceller = void 0;

    this.$onInit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.amount = _this.amount || 0;
              _this.orgName = scOrganizationsService.active.current.name;
              _this.paypal = {};
              _this.venmo = {};
              _this.FUNDING_SOURCES = [];

              _context.next = 7;
              return PayPalSDK.init({ commit: false }).then(function (paypalSDKs) {
                var paypal = paypalSDKs.paypal,
                    paypalRecurring = paypalSDKs.paypalRecurring,
                    merchantId = paypalSDKs.merchantId;

                _this.paypalOneTime = paypal;
                _this.paypalRecurring = paypalRecurring;
                _this.merchantId = merchantId;
                _this.showButtons = {};

                if (_this.hasPaypal) {
                  _this.FUNDING_SOURCES.push(_this.paypalOneTime.FUNDING.PAYPAL);
                }

                if (_this.hasVenmo) {
                  _this.FUNDING_SOURCES.push(_this.paypalOneTime.FUNDING.VENMO);
                }

                // loop through funding sources once we implement Venmo
                _this.FUNDING_SOURCES.forEach(function (fundingSource) {
                  _this.createButtons(fundingSource);
                });
              });

            case 7:

              _this.addDataIds();

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    // One time donations and recurring donations are handled differently,
    // so when the frequency changes from one to the other, we need to clear it
    this.$onChanges = function (newV) {
      var newVal = newV || {};
      // ignore $onChanges if no frequency nor amount
      if (!newVal.amount && !newVal.frequency && !newVal.fot) {
        return;
      }
      var amount = newVal && newVal.amount;
      var frequency = newVal && newVal.frequency;
      var fot = newVal && newVal.fot;

      // if amount is valid, enable for both one-time's button actions and recurring's
      // if fot or frequency was last change, make sure to enable
      if (amount && amount.currentValue && amount.currentValue !== '0' && amount.currentValue !== '0.00' || frequency || fot) {
        if (_.has(self.paypal, 'actionsOnce')) {
          self.paypal.actionsOnce.enable();
        }
        if (_.has(self.venmo, 'actionsOnce')) {
          self.venmo.actionsOnce.enable();
        }
        if (self.actionsMonthly) {
          self.actionsMonthly.enable();
        }
      } else {
        if (_.has(self.paypal, 'actionsOnce')) {
          self.paypal.actionsOnce.disable();
        }
        if (_.has(self.venmo, 'actionsOnce')) {
          self.venmo.actionsOnce.disable();
        }
        if (self.actionsMonthly) {
          self.actionsMonthly.disable();
        }
      }

      // cancel previous request if we're sending in a new request
      if (requestCanceller) {
        requestCanceller.resolve(); // cancel previous
      }
      requestCanceller = $q.defer(); // assign new one

      if (amount && amount.currentValue || fot) {
        _this.totalAmount = _this.amount;

        if (amount && _this.isValidAmount(amount.currentValue) || fot && !fot.isFirstChange()) {
          scFeeOnTopService.transactionEstimate(_this.amount, {
            processor_name: 'PAYPAL_COMMERCE',
            fot: _this.fot
          }, {
            timeout: requestCanceller.promise
          }, _this.frequency).then(function (_ref2) {
            var data = _ref2.data;
            var charge = data.charge_summary,
                grossAdjustment = data.gross_adjustment;


            if (scFeeOnTopService.donorCoveredFeesEnabled) {
              _this.totalAmount = charge.total_charge;
            }

            var feeSum = parseFloat(grossAdjustment.raw_processor_fee_amount) + parseFloat(grossAdjustment.raw_application_fee_amount);

            var fee = feeSum - _this.totalAmount * PAYPAL_FEE_RATE - PAYPAL_FEE_FIXED;

            // if fee calculation is negative, we should set platform_fees to 0
            // this should never happen, as long as our fees > paypal fees
            // but a negative platformFee prevents the modal from opening.
            _this.platformFee = fee <= 0 ? 0 : fee;
          }).catch(function () {});
        }

        // total amount will be different if campaign is classymode
        if (scFeeOnTopService.fixedFotEnabled) {
          _this.totalAmount = _this.fot ? Number(_this.amount + scFeeOnTopService.calculateFixedFeeOnTop(_this.amount)).toFixed(2) : _this.amount.toFixed(2);
        }
      }

      if (frequency && !frequency.isFirstChange()) {
        if ((_this.modelPaypal.status === STATUS.SUCCESS || _this.modelVenmo === STATUS.SUCCESS) && (frequency.currentValue === 'one-time' || frequency.previousValue === 'one-time')) {
          _this.onCancel();
        }
      }
    };

    this.isValidAmount = function (amount) {
      return amount && amount > 0 && amount !== '0' && amount !== '0.00' && amount !== 'clear';
    };

    this.showOneTime = function () {
      return _this.frequency === 'one-time' && (_this.hasPaypal || _this.hasVenmo);
    };
    this.showRecurring = function () {
      return _this.frequency !== 'one-time' && _this.hasPaypal;
    };

    var createOrder = function createOrder(fundingSource) {
      return function (_data, _actions) {
        var paymentMethod = fundingSource === 'venmo' ? 'Venmo' : 'PayPal_Commerce';
        return PayPalSDK.createOrder(_this.totalAmount, 'USD', paymentMethod);
      };
    };

    // paypal's createBillingAgreement expects us to pass in a billing token
    // the paypal sdk requests it from classypay before it is returned here
    var createBillingAgreement = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', PayPalSDK.createBillingAgreementToken());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function createBillingAgreement() {
        return _ref3.apply(this, arguments);
      };
    }();

    var setSelectedPayment = function setSelectedPayment(fundingSource) {
      _this.selectedPayment = fundingSource;
    };

    // Because the same paypal button cannot be used for both one time and recurring donations
    // We create 2 buttons, and hide the other depending on the selected frequency
    this.createButtons = function (fundingSource) {
      var style = {
        height: 40
      };

      var btnOnce = _this.paypalOneTime.Buttons({
        fundingSource: fundingSource,
        style: style,
        createOrder: createOrder(fundingSource),
        onInit: function onInit(_data, actions) {
          self[fundingSource].actionsOnce = actions;

          if (self.amount <= 0) {
            self[fundingSource].actionsOnce.disable();
          }
        },

        onApprove: onApprove,
        onClick: function onClick() {
          self.disablePaymentButtons();
          setSelectedPayment(fundingSource);
        },
        onCancel: function onCancel() {
          self.enablePaymentButtons();
          this.onCancel();
        },

        // onClick: function () {
        // [TODO @hvnt remove] -- KEEPING COMMENT HERE FOR DEV PR
        // If you are thinking just disable/enable here.. You are unforunately notcorrect.
        // When a donation amount goes from 0 to >0, it takes at least 1 digest cycle for it
        // to propogate. However, the onClick is a callback function for the PP commerce iframe.
        // Vastly diff async timings in diff systems
        // --> even though the code is in seemingly relative proximity
        // Also, using a $timeout here isn't a clean fix either; it's easy to botch the timing.
        //
        //   if (self.amount <= 0) {
        //     return $timeout(() => self.actions.disable());
        //   } else {
        //     return $timeout(() => self.actions.enable());
        //   }
        // },
        onError: onError
      });

      var btnMonthly = _this.paypalRecurring.Buttons({
        fundingSource: fundingSource,
        style: style,
        createBillingAgreement: createBillingAgreement,
        onApprove: onApproveRecurring,
        onInit: function onInit(_data, actions) {
          self.actionsMonthly = actions;

          if (self.amount <= 0) {
            self.actionsMonthly.disable();
          }
        },
        onClick: function onClick() {
          setSelectedPayment(fundingSource);
        },

        onError: onError
      });

      _this.showButtons[fundingSource] = btnOnce.isEligible(); // ? ask marcos what this does

      if (btnOnce.isEligible()) {
        btnOnce.render('#button-container-one-time');
      }

      if (btnMonthly.isEligible()) {
        btnMonthly.render('#button-container-recurring');
      }
    };

    this.addDataIds = function () {
      var btnContainerOnetime = document.getElementById('button-container-one-time');

      var btnsOneTime = btnContainerOnetime.getElementsByClassName('paypal-buttons');
      if (btnsOneTime.length > 0) {
        btnsOneTime[0].setAttribute('data-id', 'eg-paymethod-' + _this.FUNDING_SOURCES[0]);
      }

      if (btnsOneTime.length > 1) {
        btnsOneTime[1].setAttribute('data-id', 'eg-paymethod-' + _this.FUNDING_SOURCES[1]);
      }

      var btnContainerMonthly = document.getElementById('button-container-recurring');

      var btnsMonthly = btnContainerMonthly.getElementsByClassName('paypal-buttons');
      if (btnsMonthly.length > 0) {
        btnsMonthly[0].setAttribute('data-id', 'eg-paymethod-paypal');
      }
    };

    var onApprove = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, _actions) {
        var orderID;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                orderID = data.orderID;
                _context3.next = 3;
                return PayPalSDK.getOrderDetails(orderID).then(function (_ref5) {
                  var orderDetails = _ref5.data;

                  var email = _.get(orderDetails, 'payer.email_address');
                  var firstName = _.get(orderDetails, 'payer.name.given_name');
                  var lastName = _.get(orderDetails, 'payer.name.surname');
                  var shippingAddress = _.get(orderDetails, 'purchase_units[0].shipping.address');
                  var details = {
                    email: email,
                    firstName: firstName,
                    lastName: lastName,
                    orderId: orderID,
                    status: STATUS.SUCCESS,
                    shippingAddress: shippingAddress
                  };

                  _this.onSuccess({ params: { details: details, fundingSource: _this.selectedPayment } });
                });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function onApprove(_x, _x2) {
        return _ref4.apply(this, arguments);
      };
    }();

    var onApproveRecurring = function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_data, _actions) {
        var agreementId, details;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                agreementId = PayPalSDK.getBillingAgreementToken();
                details = {
                  email: 'PayPal Account',
                  agreementId: agreementId,
                  status: STATUS.SUCCESS
                };
                _context4.prev = 2;
                _context4.next = 5;
                return PayPalSDK.getBillingAgreementTokenDetails(agreementId).then(function (_ref7) {
                  var data = _ref7.data;

                  details.email = _.get(data, 'payer_info.email');
                  details.firstName = _.get(data, 'payer_info.first_name');
                  details.lastName = _.get(data, 'payer_info.last_name');
                  details.shippingAddress = _.get(data, 'shipping_address');
                });

              case 5:
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](2);

                $log.warn('[egPayPaypalCommerce:onApproveRecurring] ERR: ', _context4.t0);

              case 10:

                _this.onSuccess({ params: { details: details } });

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this, [[2, 7]]);
      }));

      return function onApproveRecurring(_x3, _x4) {
        return _ref6.apply(this, arguments);
      };
    }();

    var onError = function onError(err) {
      $timeout(function () {
        if (!_this.amount || _this.amount <= 0) {
          // scBanner(
          //   `Please choose an amount before paying with ${
          //     this.selectedPayment === 'paypal' ? 'PayPal' : 'Venmo'
          //   }`,
          //   'error'
          // );
        } else {
          bugsnagClient.notify(err);
          // scBanner(
          //   'There was an error with PayPal. Please try again, or try using a different payment method.',
          //   'error'
          // );
        }
      });
    };
  }]
});
})();